const ReviewPageButton = ({ assignment, showReviewPage }) => {
  return (
    <div
      style={{
        textAlign: "center",
        fontSize: "16px",
        backgroundColor: assignment.finished_at ? "#2D2D2D" : "#F6F8FA",
        color: assignment.finished_at ? "white" : "black",
        border: "1px solid #EBEBEB",
        borderRadius: "5px",
        padding: "3px",
        width: "110px",
        cursor: "pointer",
      }}
      onClick={() => showReviewPage(assignment)}
    >
      {assignment.finished_at
        ? assignment.grade + "점"
        : assignment.progress_rate + "% 완료"}
    </div>
  );
};

export default ReviewPageButton;
